import { Tkv2PublicRecord } from '@aloft/toolkit-shared';

export function getMarketLandToValueRatio(
  publicRecordData: Tkv2PublicRecord | undefined,
): number | null {
  if (!publicRecordData) {
    return null;
  }

  const { TaxMarketValueImprovements, TaxMarketValueLand } = publicRecordData;

  const MarketLandPlusImprovements = TaxMarketValueLand?.add(TaxMarketValueImprovements);
  return MarketLandPlusImprovements &&
    TaxMarketValueLand &&
    MarketLandPlusImprovements.unitAmount > 0
    ? TaxMarketValueLand.ratio(MarketLandPlusImprovements)
    : null;
}
